import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-radio.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const RadioIcon = createSvgIcon(<Icon />, 'RadioIcon');
